//EditAdjustIBM.tsx ==============================================================
import "../Util/Prototypes";

import * as Default from "../Default";
import * as DrawerMenu from "../Menus/DrawerMenu";
import * as EditValuesIBM from "./EditValuesIBM";
import * as Settings from "../Settings";
import * as Search from "../Search/Search";
import * as SignIn_Auth0 from "../Util/SignIn_Auth0";
import * as SnackBar from "../Util/SnackBar";
import * as Spinner from "../Util/Spinner";
import * as Util from "../Util/Util";
import * as Util_App from "../Util/Util_App";
import * as Util_MUI from "../Util/Util_MUI";
import * as WidgetHeading from "../Widgets/WidgetHeading";

import {
   Button, FormControl, FormControlLabel, FormGroup, FormLabel, InputAdornment, InputLabel, Paper, Radio, Select, TextField
} from "@mui/material";

import Axios, { AxiosResponse } from "axios";

import React from "react";

const toolName: string = "Adjust residential market values";

let percentNum: number = 5;
let percentAny: string = "5";

let valueNum: number = 10000;
let valueAny: string = "10000";

let adjustType: string = "Improvements";
let applyDisabled: boolean = false;

let mode: string = "Percent";  //Percent, Value, or Done.

let percentMode: boolean = true; //Radio button values.
let valueMode: boolean = false;
let doneMode: boolean = false;

interface iProps {
}

//Render function.
export function Render(props: iProps) {
   //Util.logMsg("Top of Edit Render");

   if (DrawerMenu.curToolName === "") {
      return (<div />);
   }

   //Set refresh method.
   const [ignored, refresh] = React.useReducer((x: number) => x + 1, 0);

   //Component did mount.
   React.useEffect(() => {
   }, []);

   //Close this tool.
   function close() {
      DrawerMenu.closeTool();
   }

   //Adjust by mode changed.
   function modeChanged(event: any): void {
      const checked: boolean = event.target.checked;
      const value: string = event.target.defaultValue;

      mode = value;

      if (mode === "Percent") {
         percentMode = checked;
         valueMode = !checked;
         doneMode = !checked;

      } else if (mode === "Value") {
         percentMode = !checked;
         valueMode = checked;
         doneMode = !checked;

      } else {
         percentMode = !checked;
         valueMode = !checked;
         doneMode = checked;
      }
      refresh();
   }

   //Percent to adjust values changed.
   function percentChanged(event: any) {
      const value: number = Util.parseInteger(event.target.value);
      percentNum = Math.min(value, 100);
      percentNum = Math.max(percentNum, -100);

      percentAny = percentNum.toString();
      if (percentNum === 0) {
         percentAny = "";
      }
      refresh();
   }

   //Value to set changed.
   function valueChanged(event: any) {
      const value: number = Util.parseInteger(event.target.value);
      valueNum = Math.min(value, 300000);
      valueNum = Math.max(valueNum, 0);

      valueAny = valueNum.toString();
      if (valueNum === 0) {
         valueAny = "";
      }
      refresh();
   }

   //Adjustment type changed.
   function typeChanged(event: any) {
      adjustType = event.target.value;
      refresh();
   }

   //Increase values.
   function adjustValues() {
      if (Search.grandTotRec === 0) {
         return; //Quit if clear button was pressed.
      }

      if (Spinner.busy) {
         return; //Quit if busy.
      }
      Spinner.show();

      let i: number;
      let feature: any;
      const pinList: string[] = [];
      const ii: number = Search.activeLayerIndex;

      //Build list of pins.
      for (i = 0; i < Search.layers[ii].fs.features.length; i++) {
         feature = Search.layers[ii].fs.features[i];
         const fields: Util_App.iField[] = Util_App.getFeatureValues(Search.layers[ii].fs, feature, Settings.parcelLayerName, Settings.pin_fieldName);
         pinList.Add(fields[0].value);
      }

      //Set values on server.
      let value: number = percentNum;
      if (valueMode) {
         value = valueNum;
      }
      const ajaxData: Default.iAjaxData = { action: "adjustAppraisedValuesIBM", userName: SignIn_Auth0.userName, percentOrValue: value, mode: mode, adjustType: adjustType, pinList: pinList };

      const webAPI_path = Util_App.getWebAPI_path();

      Axios.post(webAPI_path, ajaxData)
         .then(function (response) {
            setTimeout(function () { Spinner.hide(); }, 500); //Wait to avoid fumble finger multiple clicks.

            if (!response) {
               Util.errMsg("ajax results from server are null");
               return;
            }
            if (response.data.errMsg !== "") {
               SnackBar.show(response.data.errMsg);
               return;
            }
            SnackBar.show("Successfully changed improvement values", 2);
            EditValuesIBM.refreshMap();
         })
         .catch(function (error) {
            Spinner.hide();
            Util.errMsg("ajax error setting IBM values.", error);
         });
   }

   //Set visibility of text boxes.
   let percentVisible: boolean = true;
   let valueVisible: boolean = false;
   if (valueMode) {
      percentVisible = false;
      valueVisible = true;
   }

   //Apply button.
   applyDisabled = false;

   if (percentMode) {
      if (percentNum === 0) {
         applyDisabled = true;
      }
   } else if (valueMode) {
      if (valueNum < 50) {
         applyDisabled = true;
      }
   }

   return (
      <Paper>
         <WidgetHeading.Render title={"Adjust residential market values"} onClose={close} />

         <FormControl style={{ marginLeft: 15, marginTop: 7 }}>
            <FormLabel>Adjust By</FormLabel>

            <FormGroup row={true}>
               <FormControlLabel title="Adjust by percentage"
                  control={<Radio key={Util.uid()} value="Percent" checked={percentMode} color="primary" onChange={modeChanged} />}
                  label="Percentage"
               />
               <FormControlLabel title="Adjust by value"
                  control={<Radio key={Util.uid()} value="Value" checked={valueMode} color="primary" onChange={modeChanged} />}
                  label="Value"
               />
               <FormControlLabel title="Set reassessment complete"
                  control={<Radio key={Util.uid()} value="Done" checked={doneMode} color="primary" onChange={modeChanged} />}
                  label="Done"
               />
            </FormGroup>
         </FormControl>

         <div className="app-flex-row-around" style={{ padding: 7 }}>

            {percentVisible &&
               <TextField style={{ width: 80 }} title="Percent to adjust appraised values" autoComplete="off"
                  id="adjust-percent"
                  label="Percentage"
                  type="number"
                  margin="dense"
                  InputProps={{ endAdornment: <InputAdornment position="end">%</InputAdornment> }}
                  inputProps={{ min: "-100", max: "100" }}
                  value={percentAny}
                  onChange={percentChanged}
               />
            }

            {valueVisible &&
               <TextField style={{ width: 95 }} title="Value to adjust appraised values" autoComplete="off"
                  id="adjust-value"
                  label="Value"
                  type="number"
                  margin="dense"
                  InputProps={{ startAdornment: <InputAdornment position="start">$</InputAdornment> }}
                  inputProps={{ min: "0", max: "300000" }}
                  value={valueAny}
                  onChange={valueChanged}
               />
            }

            <FormControl variant="outlined">
               <InputLabel id="adjust-type">Residential</InputLabel>
               <Select title="Adjustment Type"
                  labelId="adjust-type"
                  label="Residential"
                  value={adjustType}
                  onChange={typeChanged}
               >
                  {Util_MUI.buildSelectMenuItems(["Land", "Agricultural Land", "Improvements", "Agricultural Improvements", "Mobile Homes"])}
               </Select>
            </FormControl>

            <Button variant="contained" size="medium" color="primary" onClick={adjustValues} disabled={applyDisabled} title="Increase or decrease values">
               Apply
            </Button>
         </div>

      </Paper>
   ); //end return.

} //end function.
